<template>
  <BasePage :pageTitle=__DICT__.menuOptions.SearchStaff show-menu show-footer>
    <Card margin="mb-4">
      <!-- Search Input -->
      <div class="input-icon mb-3">
        <input
            type="text"
            class="form-control"
            :placeholder="__DICT__.enterRepName"
            v-model="searchQuery"
        >
        <span class="input-icon-addon">
          <IconSearch class="icon" :size="24" />
        </span>
      </div>

      <!-- Staff Type Filter -->
      <div class="mb-3">
        <Select v-model="selectedStaffType" :options="staffTypeOptions" />
      </div>

      <!-- Results Table -->
      <div v-if="filteredReps.length > 0" class="table-responsive">
        <table class="table table-vcenter card-table">
          <thead>
          <tr>
            <th>{{ __DICT__.name }}</th>
            <th>{{ __DICT__.staffType }}</th>
          </tr>
          </thead>
          <tbody>
          <tr
              @click="selectRep(rep)"
              v-for="rep in filteredReps"
              :key="`${rep['GBS ID']}-${rep.tenant}`"
              class="position-relative"
              :style="{
      borderLeft: `5px solid ${getRowColor(rep)}`
    }"
          >
            <td>{{ rep.Name }}</td>
            <td>{{ rep['Staff Type'] }}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <!-- No Results Message -->
      <div v-else-if="searchQuery && !isLoading" class="empty">
        <div class="empty-icon">
          <IconMoodSad class="icon" :size="24" />
        </div>
        <p class="empty-title">{{ __DICT__.noResultsFound }}</p>
        <p class="empty-subtitle text-muted">
          {{ __DICT__.tryAdjustingSearch }}
        </p>
      </div>

      <!-- Loading Spinner -->
      <LoadingSpinner v-if="isLoading" color="blue" :text="__DICT__.searching" />
    </Card>
  </BasePage>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useWeekStore } from '@/stores/week.js'
import { usePermissions } from '@/composables/usePermissions'
import BasePage from "@/components/BasePage.vue"
import router from "@/router/index.js"
import { Card, Select, LoadingSpinner } from "@/components/atomic"
import { IconSearch, IconMoodSad } from '@tabler/icons-vue'
import { getRepColor } from '@/utils/accommodationUtils.js'

const weekStore = useWeekStore()
const { filter } = usePermissions()
const searchQuery = ref('')
const selectedStaffType = ref('')
const isLoading = ref(true)
const repData = ref([])

// Compute unique staff types for the filter dropdown
const staffTypes = computed(() => {
  const filtered = filteredReps.value
  if (filtered.length > 0) {
    const types = new Set(filtered.map(rep => rep['Staff Type']))
    return Array.from(types).sort()
  }
  return []
})

const staffTypeOptions = computed(() => [
  { value: '', label: 'All Staff Types' },
  ...staffTypes.value.map(type => ({ value: type, label: type }))
])

// Filter reps based on permissions, search query and staff type
const filteredReps = computed(() => {
  console.log(repData.value)
  if (!repData.value?.length) return []
  // First apply permission-based filtering
  let filtered = filter(repData.value, 'viewStaff')
  console.log(filtered)
  // Filter by search query
  if (searchQuery.value) {
    const query = searchQuery.value.toLowerCase()
    filtered = filtered.filter(rep =>
        rep.Name?.toLowerCase().includes(query)
    )
  }

  // Filter by staff type
  if (selectedStaffType.value) {
    filtered = filtered.filter(rep =>
        rep['Staff Type'] === selectedStaffType.value
    )
  }

  return filtered
})

async function loadRepData() {
  isLoading.value = true
  try {
    repData.value = await weekStore.repData
  } catch (error) {
    console.error('Error loading rep data:', error)
  } finally {
    isLoading.value = false
  }
}

function selectRep(rep) {
  router.push(`/rep/${rep['GBS ID']}`)
}

const getRowColor = getRepColor

onMounted(() => {
  loadRepData()
})
</script>